import React from 'react'
import {BaseModal} from '../BaseModal/BaseModal'
import styles from './NoPermission.module.scss'
import {cx} from '../../utils'
import {ReactComponent as Workforce} from '../../assets/Icons/Workforce.svg'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {HOME} from '../../Translation/English/home'

export const NoPermissionEmpower = (): React.JSX.Element => {
  const wt = useWt()

  return (
    <BaseModal visible={true} hideHeader={true} onCloseModal={() => {}}>
      <div className={styles.noPermission}>
        <div className={styles.noPermissionHeader}>
          <p className={styles.noPermissionHeaderTitle}>{wt(HOME.noAccess)}</p>
        </div>
        <div
          className={cx(
            styles.noPermissionMain,
            styles.noPermissionEmpowerMain,
          )}
        >
          <div className={styles.noPermissionEmpowerMainBlock1}>
            <h2 className={styles.noPermissionMainTitle}>
              {wt(HOME.empowerText1)}
            </h2>
            <p className={styles.noPermissionMainDescription}>
              {wt(HOME.empowerText2)}
            </p>
            <p className={styles.noPermissionMainDescription}>
              {wt(HOME.contactSupport)}
            </p>
          </div>
          <div className={styles.noPermissionEmpowerMainBlock2}>
            <Workforce />
          </div>
        </div>
      </div>
    </BaseModal>
  )
}
